import { TrashCan } from "@carbon/icons-react";
import { t } from "i18next";
import { enqueueSnackbar } from "notistack";
import { useState } from "react";

import useCancelTimeSlotMutation from "../../../../hooks/graphql-hooks/mutations/useCancelTimeSlotMutation";
import useNavigateTo from "../../../../hooks/useNavigateTo";
import { TimeSlotBooking } from "../../../../models/timeSlotBooking";
import CancelTimeSlotAlertDialog from "../../../alertDialog/extendedAlertDialogs/cancelTimeSlotAlertDialog/CancelTimeSlotAlertDialog";
import DeliveryAction from "../DeliveryAction";

interface DeliveryActionCancelTimeSlotCancel {
  deliveryId: string;
}

const DeliveryActionCancelTimeSlot = (
  props: DeliveryActionCancelTimeSlotCancel,
) => {
  const { deliveryId } = props;
  const { navigateToDeliveryDetails } = useNavigateTo();

  const [showCancelDialog, setShowCancelDialog] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState<TimeSlotBooking[]>([]);

  const [cancelTimeSlot, { loading }] = useCancelTimeSlotMutation({
    inboundDeliveryId: deliveryId,
    dataAction: () => handleCancelSuccess(),
  });

  const handleCancelSuccess = () => {
    setShowCancelDialog(false);
    enqueueSnackbar(t("cancelTimeSlotSuccessful"), {
      variant: "success",
    });
    navigateToDeliveryDetails(deliveryId);
  };

  const handleConfirmCancelTimeSlot = async () => {
    for (const booking of selectedOptions) {
      try {
        await cancelTimeSlot({
          variables: {
            cancelTimeSlotInput: {
              inboundDeliveryId: deliveryId,
              slotId: booking.timeSlotId,
            },
          },
        });
      } catch (error) {}
    }
  };

  const handleCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    option: TimeSlotBooking,
  ) => {
    const { checked } = event.target;

    if (checked) {
      setSelectedOptions([...selectedOptions, option]);
    } else {
      setSelectedOptions(
        selectedOptions.filter(
          (selectedOption) => selectedOption.timeSlotId !== option.timeSlotId,
        ),
      );
    }
  };

  return (
    <>
      <DeliveryAction
        icon={<TrashCan size={24} />}
        label={t("cancelTimeSlot")}
        onClick={() => setShowCancelDialog(true)}
      />
      {showCancelDialog && (
        <CancelTimeSlotAlertDialog
          deliveryId={deliveryId}
          showDialog={showCancelDialog}
          selectedOptions={selectedOptions}
          loading={loading}
          setShowDialog={setShowCancelDialog}
          handleConfirm={handleConfirmCancelTimeSlot}
          onCheckBoxChange={handleCheckboxChange}
        />
      )}
    </>
  );
};
export default DeliveryActionCancelTimeSlot;
